<template>
    <main class="wrapper">
        <el-row class="title">一级标签</el-row>
        <el-row style="margin-bottom: 20px;">
            <el-button size="small" type="primary" @click="add"
                >新增一级标签
            </el-button>
        </el-row>
        <el-table
            :data="tableData"
            style="width: 100%"
            row-key="id"
            border
            lazy
            :load="load"
            :tree-props="{ children: 'children', hasChildren: 'hasChildren' }"
        >
            <el-table-column prop="id" label="id"> </el-table-column>
            <el-table-column prop="name" label="标签名称"> </el-table-column>
            <el-table-column label="操作">
                <template slot-scope="scope">
                    <el-button
                        size="mini"
                        type="primary"
                        @click="handleAdd(scope.row)"
                        v-if="scope.row.pId == 0"
                        >新增</el-button
                    >
                    <el-button
                        size="mini"
                        @click="handleEdit(scope.row)"
                        >编辑</el-button
                    >
                    <el-button
                        size="mini"
                        type="danger"
                        @click="handleDelete(scope.row)"
                        >删除</el-button
                    >
                </template>
            </el-table-column>
        </el-table>

        <el-dialog
            :title="
                (curId ? '编辑' : '新增') + (curPId ? '二级标签' : '一级标签')
            "
            :visible.sync="dialogVisible"
            width="40%"
        >
            <el-form>
                <el-form-item
                    label="父级标签名称"
                    label-width="100px"
                    v-if="curPId"
                >
                    <el-input v-model="pName" :disabled="true"></el-input>
                </el-form-item>
                <el-form-item label="标签名称" label-width="100px">
                    <el-input v-model="labelName"></el-input>
                </el-form-item>
            </el-form>

            <div slot="footer" class="dialog-footer">
                <el-button @click="dialogVisible = false">取消</el-button>
                <el-button type="primary" @click="save">确认</el-button>
            </div>
        </el-dialog>
    </main>
</template>
<script type="text/javascript">
import { getLabelList, createLabel, editLabel,deleteLabel } from "@/api/group";

import { formatDate } from "@/utils/util";
export default {
    inject: ["reload"],
    data() {
        return {
            tableData: [],
            tableHeaders: [
                {
                    headerKey: "id",
                    headerName: "id",
                },
                {
                    headerKey: "name",
                    headerName: "标签名称",
                },
            ],
            clickData: [
                {
                    label: "详情",
                    value: "detail",
                },
            ],
            level: 1,
            curId: 0,
            curPId: 0,
            dialogVisible: false,
            labelName: "",
        };
    },
    mounted() {
        this.getList();
    },
    methods: {
        getList() {
            getLabelList({
                pId: 0,
            }).then((res) => {
                //一级
                let temp = res.data.resp.data;
                temp.forEach((item) => {
                    item.hasChildren = true;
                    item.level = 1;
                });
                this.tableData = temp;
            });
        },
        load(tree, treeNode, resolve) {
            getLabelList({
                pId: tree.id,
            }).then((res) => {
                let temp = res.data.resp.data;
                temp.forEach((item) => {
                    item.pName = tree.name;
                });
                resolve(temp);
            });
        },
        handleDelete(row) {
            this.$confirm("确认删除吗？", "警告").then((res) => {
                deleteLabel({
                    labelId: row.id,
                }).then(() => {
                    this.$message.success("删除成功！");
                    this.reload();
                });
            });
        },
        handleAdd(row) {
            this.curId = 0;
            this.curPId = row.id;
            this.pName = row.name;
            this.dialogVisible = true;
        },
        handleEdit(row) {
            this.curId = row.id;
            this.curPId = row.pId;
            this.pName = row.pName;
            this.labelName = row.name;
            this.dialogVisible = true;
        },
        add() {
            this.curId = 0;
            this.curPId = 0;
            this.dialogVisible = true;
        },
        clearData(){
            this.curId = 0;
            this.curPId = 0;
            this.pName = '';
            this.labelName = '';
            this.dialogVisible = false;
        },
        save() {
            if (this.curId) {
                //edit
                editLabel({
                    labelId: this.curId,
                    labelName: this.labelName,
                    pId: this.curPId,
                }).then((res) => {
                    this.$message.success("修改成功！");
                    this.clearData();
                    this.reload();
                });
                return;
            }
            createLabel({
                labelName: this.labelName,
                pId: this.curPId,
            }).then((res) => {
                this.$message.success("创建成功！");
                 this.clearData();
                this.reload();
            });
        },
    },
};
</script>
<style lang="less">
.filter-tree,
.wrapper-search {
    margin-top: 30px;
}

.title {
    font-size: 20px;
    margin-bottom: 25px;
}
</style>
